import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshwartaxi() {



const cardData = {
  keyword: "Mumbai to Mahabaleshwar Taxi",
  heading: "Lotus Cab: Mumbai to Mahabaleshwar Taxi",

headingDescription:
    "Lotus Cabs offers reliable and affordable Mumbai to Mahabaleshwar Cab services for family vacations, weekend getaways, honeymoon trips, corporate travel, sightseeing tours, group travel, and one-way or round-trip journeys. We provide a premium fleet of AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Mumbai, well-maintained vehicles, and safe highway travel via the Mumbai–Pune Expressway, Lotus Cabs ensures a smooth, comfortable, and hassle-free journey to the beautiful hill station of Mahabaleshwar.",

  top: "Top Places to Visit in Mahabaleshwar with Lotus Cab",

  topPlaces: [
    {
        title: "Venna Lake",
        description:
            "Venna Lake is one of Mahabaleshwar's most popular tourist attractions and a favorite destination for families, couples, and nature lovers. Visitors can enjoy boating, horse riding, lakeside walks, and delicious local snacks while surrounded by lush greenery and the cool climate of the Western Ghats. The peaceful atmosphere and scenic beauty make Venna Lake an essential stop during every Mumbai to Mahabaleshwar trip."
    },
    {
        title: "Arthur's Seat",
        description:
            "Arthur's Seat is one of the most spectacular viewpoints in Mahabaleshwar, offering breathtaking panoramic views of deep valleys, dense forests, and the Savitri River. Often called the 'Queen of Points,' it is a paradise for photographers and nature enthusiasts who wish to experience the magnificent landscapes of the Sahyadri mountain range."
    },
    {
        title: "Mapro Garden",
        description:
            "Mapro Garden is a must-visit attraction famous for its strawberry products, fresh fruit juices, chocolates, sandwiches, pizzas, and beautifully landscaped gardens. Families and tourists enjoy tasting local specialties, shopping for jams and syrups, and relaxing amidst the colorful surroundings throughout the year."
    },
    {
        title: "Elephant's Head Point",
        description:
            "Elephant's Head Point is named after its naturally formed rock structure that resembles an elephant's head and trunk. The viewpoint offers mesmerizing views of valleys, cliffs, and surrounding mountains, making it one of the most photographed destinations in Mahabaleshwar, especially during sunrise and sunset."
    },
    {
        title: "Wilson Point",
        description:
            "Wilson Point is the highest viewpoint in Mahabaleshwar and is renowned for offering panoramic sunrise and sunset views over the Sahyadri Hills. The cool breeze, peaceful environment, and expansive mountain scenery make it a favorite destination for photographers, families, and early morning visitors."
    },
    {
        title: "Pratapgad Fort",
        description:
            "Pratapgad Fort is one of Maharashtra's most historically significant forts, closely associated with the legendary battle between Chhatrapati Shivaji Maharaj and Afzal Khan. Visitors can explore the impressive fortifications, Bhavani Temple, watchtowers, and breathtaking hilltop views while learning about the region's rich Maratha history."
    },
    {
        title: "Lingmala Waterfall",
        description:
            "Lingmala Waterfall is among the most beautiful waterfalls in Mahabaleshwar, especially during the monsoon season when the cascading water flows at full force. Surrounded by dense forests and picturesque landscapes, it is a perfect destination for photography, nature walks, and peaceful relaxation."
    },
    {
        title: "Mahabaleshwar Temple",
        description:
            "The ancient Mahabaleshwar Temple is dedicated to Lord Shiva and is one of the region's most important pilgrimage sites. Known for its centuries-old Hemadpanti architecture and sacred Shiva Lingam, the temple attracts devotees from across India seeking spiritual blessings in a serene and historic setting."
    },
    {
        title: "Panchgani",
        description:
            "Located just a short drive from Mahabaleshwar, Panchgani is a charming hill station known for Table Land, Sydney Point, Parsi Point, strawberry farms, and colonial-era schools. Travelers often combine both destinations to enjoy scenic viewpoints, pleasant weather, and memorable sightseeing experiences."
    },
    {
        title: "Tapola",
        description:
            "Tapola, often referred to as the 'Mini Kashmir of Maharashtra,' is famous for the beautiful Shivsagar Lake, boating, kayaking, camping, and lush green surroundings. Adventure enthusiasts and families visiting Mahabaleshwar frequently include Tapola in their itinerary to experience its peaceful natural beauty and exciting outdoor activities."
    }
],

  services: [
    {
      name: "Mumbai to Mahabaleshwar Taxi",
      description:
        "Reliable Mumbai to Mahabaleshwar taxi service with experienced hill drivers. Clean AC vehicles ensure comfortable long-distance travel. Flexible pickup locations across Mumbai available. Suitable for families, couples, and group travel. Transparent per-km pricing shared before booking. 24/7 booking support provided."
    },
    {
      name: "One Way Cab Mumbai to Mahabaleshwar",
      description:
        "Affordable one-way taxi option where you pay only for single-side distance. Ideal for drop services and relocation travel. AC sedans and SUVs available. Professional drivers ensure safe hill driving. No hidden charges policy maintained. Instant booking confirmation provided."
    },
    {
      name: "Round Trip Cab Mumbai to Mahabaleshwar",
      description:
        "Round-trip cab service with flexible return schedule options. Perfect for weekend trips and short vacations. Comfortable AC vehicles suitable for hill roads. Transparent fare structure. Safe and smooth travel ensured. Convenient booking process."
    },
    {
      name: "Family Trip Cab Mumbai to Mahabaleshwar",
      description:
        "Spacious SUV and sedan options ideal for family travel. Extra luggage capacity available. Safe hill driving experience provided. Comfortable AC interiors maintained. Affordable pricing available. Flexible return options provided."
    },
    {
      name: "Luxury Cab Mumbai to Mahabaleshwar",
      description:
        "Premium luxury vehicles available for comfortable hill station travel. Ideal for honeymoon couples and VIP guests. Professional chauffeur-driven service included. Smooth and quiet ride guaranteed. Customized travel packages available."
    },
    {
      name: "SUV Cab Mumbai to Mahabaleshwar",
      description:
        "SUV taxis suitable for hill terrain and group travel. Comfortable seating and ample luggage space. Experienced drivers for mountain roads. Clean and sanitized interiors maintained. Flexible booking options available."
    }
  ],

  tableData: [
    ["Mumbai to Mahabaleshwar Taxi", "One Way Cab Mumbai to Mahabaleshwar"],
    ["Round Trip Cab Mumbai to Mahabaleshwar", "Family Trip Cab Mumbai to Mahabaleshwar"],
    ["Luxury Cab Mumbai to Mahabaleshwar", "SUV Cab Mumbai to Mahabaleshwar"],
    ["Sedan Cab Mumbai to Mahabaleshwar", "AC Cab Mumbai to Mahabaleshwar"],
    ["Online Cab Booking Mumbai to Mahabaleshwar", "Weekend Trip Cab Mumbai to Mahabaleshwar"],
    ["Corporate Cab Mumbai to Mahabaleshwar", "Chauffeur Driven Cab Mumbai to Mahabaleshwar"],
    ["Outstation Cab Mumbai to Mahabaleshwar", "Mini Bus Mumbai to Mahabaleshaleshwar"],
    ["Budget Cab Mumbai to Mahabaleshwar", "Picnic Trip Cab Mumbai to Mahabaleshwar"],
    ["Same Day Return Cab Mumbai to Mahabaleshwar", "Best Cab Service Mumbai to Mahabaleshwar"],
    ["Per Km Rate Cab Mumbai to Mahabaleshwar", "Group Tour Cab Mumbai to Mahabaleshwar"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Hill Drivers",
      WhyChoosedescription:
        "Our drivers are trained for safe mountain road navigation. They ensure careful driving on curves and slopes. Highway and ghat driving expertise provided."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear and upfront pricing shared before booking confirmation. No hidden toll or fuel surprises."
    },
    {
      WhyChooseheading: "24/7 Availability",
      WhyChoosedescription:
        "Early morning and late-night pickup available across Mumbai."
    },
    {
      WhyChooseheading: "Wide Vehicle Options",
      WhyChoosedescription:
        "Sedan, SUV, luxury, and group travel vehicles available."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Suitable packages for corporate events and family vacations."
    },
    {
      WhyChooseheading: "Clean & Sanitized Vehicles",
      WhyChoosedescription:
        "Regular maintenance and hygiene checks conducted."
    },
    {
      WhyChooseheading: "Flexible Travel Packages",
      WhyChoosedescription:
        "One-way, round-trip, and same-day return packages available."
    },
    {
      WhyChooseheading: "Reliable Customer Support",
      WhyChoosedescription:
        "Dedicated support team available during entire trip."
    }
  ]
};

const faqData = [
  { question: "Do you provide one-way cab to Mahabaleshwar?", answer: "Yes, affordable one-way taxi service available with transparent pricing and safe hill travel." },
  { question: "Is SUV recommended for Mahabaleshwar?", answer: "SUVs are recommended for comfortable hill road travel and family trips." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return packages available for weekend travel." },
  { question: "Are drivers experienced for ghat roads?", answer: "Yes, drivers are trained and experienced in mountain road driving." },
  { question: "Is AC included?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Do you offer luxury vehicles?", answer: "Yes, premium luxury car options available." },
  { question: "Is corporate booking available?", answer: "Yes, corporate packages with invoice support available." },
  { question: "Is online booking available?", answer: "Yes, instant booking confirmation provided online." },
  { question: "Is fare per km transparent?", answer: "Yes, clear per-km fare shared before confirmation." },
  { question: "Is group travel available?", answer: "Yes, SUV and mini bus options available for group tours." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Shah",
    feedback:
      "Booked round-trip cab from Mumbai to Mahabaleshwar. Driver was professional and hill driving was very smooth. Excellent service.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Kavita Joshi",
    feedback:
      "Family weekend trip was very comfortable. SUV was spacious and clean. Highly recommended service.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Luxury cab option was perfect for our business guest travel. Punctual and reliable.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Nilesh Patil",
    feedback:
      "Transparent pricing and safe hill travel. Very satisfied with overall experience.",
    rating: 5
  }
];





























































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Mahabaleshwar Cab",
"image": "https://lotuscab.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg",
"description": "Book Mumbai to Mahabaleshwar Cab with Lotus Cab for safe, comfortable, and affordable hill station travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "9320"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/mumbai-to-mahabaleshwar-cab"
}
};








  return (
    <div>
      

<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Mumbai to Mahabaleshwar Cab with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, professional drivers, instant booking, and 24x7 support for a smooth hill station journey."
/>

<meta
 name="keywords"
 content="Mumbai to Mahabaleshwar Cab, Mumbai Mahabaleshwar Taxi, Mahabaleshwar Cab from Mumbai, Mumbai to Mahabaleshwar Taxi Service, One Way Cab Mumbai to Mahabaleshwar, Round Trip Cab Mumbai to Mahabaleshwar, Outstation Cab Mumbai to Mahabaleshwar, Hill Station Cab Mumbai, Affordable Mumbai to Mahabaleshwar Cab, Cheap Mumbai to Mahabaleshwar Taxi, Online Mumbai Cab Booking, Sedan Cab Mumbai to Mahabaleshwar, SUV Cab Mumbai to Mahabaleshwar, Best Mumbai Mahabaleshwar Cab, Lotus Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/58.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomahabaleshwartaxi;